import { useState } from "react";
import { PRODUCTS } from "@/lib/site-data";
import { Button } from "@/components/ui/button";
import QuoteDialog from "@/components/QuoteDialog";
import { CheckCircle2 } from "lucide-react";

export default function Products() {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <section className="bg-sky-50/60 py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold tracking-widest text-[#1e5ba8]">PRODUCTS</p>
          <h1 className="font-display font-bold text-5xl sm:text-6xl text-[#0f172a] mt-3 tracking-tight">Our Onion Range</h1>
          <p className="text-slate-600 mt-4 max-w-2xl">Premium Indian onions sorted, graded and packed for global buyers.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-14">
        {PRODUCTS.map((p, idx) => (
          <div key={p.id} id={p.id} className={`grid lg:grid-cols-2 gap-10 items-center ${idx % 2 ? "lg:flex-row-reverse" : ""}`}>
            <img src={p.image} alt={p.name} className={`rounded-2xl w-full h-[360px] object-cover shadow-lg ${idx % 2 ? "lg:order-2" : ""}`} />
            <div>
              <h2 className="font-display font-bold text-3xl text-[#0f172a]">{p.name}</h2>
              <p className="text-slate-600 mt-3">{p.desc}</p>
              <ul className="mt-5 space-y-2">
                {["Farm fresh & handpicked", "Strict quality control", "Hygienic packing", "Reliable global shipping"].map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-slate-700">
                    <CheckCircle2 className="w-4 h-4 text-[#1e5ba8]" /> {f}
                  </li>
                ))}
              </ul>
              <Button
                onClick={() => setOpen(true)}
                className="mt-6 bg-[#1e5ba8] hover:bg-[#164582] text-white font-semibold"
                data-testid={`product-quote-${p.id}`}
              >
                REQUEST A QUOTE
              </Button>
            </div>
          </div>
        ))}
      </section>

      <QuoteDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
